import { ComponentRef, Directive, Input, OnChanges, OnDestroy, SimpleChanges, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ReportParameterComponent } from './report-parameter-component';
import { ReportParameterComponentAccessor } from './report-parameter-component-accessor';
import { ReportParameterConfig } from './report-parameter.config';

@Directive({
    selector: '[ndtDynamicReportParameter]',
    standalone: false
})
export class DynamicReportParameterDirective implements OnChanges, OnDestroy {
   @Input() config: ReportParameterConfig;

   @Input() componentAccessor: ReportParameterComponentAccessor;

   @Input() group: UntypedFormGroup;

   // askComponent: ComponentRef<AskParameterComponent> | null = null;

   component: ComponentRef<ReportParameterComponent> | null = null;

   constructor(private viewContainerRef: ViewContainerRef) {}

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.config) {
         this.destroyComponents();

         if (this.config && this.config.type !== 'hidden') {
            // if (this.config.showAskParameterOption) {
            //    const askComponentFactory = this.componentFactoryResolver.resolveComponentFactory(AskParameterComponent);
            //    this.askComponent = this.viewContainerRef.createComponent(askComponentFactory);
            //    this.askComponent.instance.form = this.group;
            // }
            const componentType = this.componentAccessor(this.config);
            this.component = this.viewContainerRef.createComponent(componentType);
            this.component.instance.config = this.config;
            this.component.instance.form = this.group;
         }
      }
   }

   ngOnDestroy(): void {
      this.destroyComponents();
   }

   private destroyComponents(): void {
      // if (this.askComponent) {
      //    this.askComponent.destroy();
      // }
      if (this.component) {
         this.component.destroy();
      }
   }
}
